import LegalPage from "@/pages/legal/LegalPage";

export default function TermsOfServicePage() {
  return (
    <LegalPage
      title="Terms of Service"
      slug="terms-of-service"
      testIdPrefix="legal-terms"
    />
  );
}
